// People-status values (mirror of the STATUS_* constants on the API's
// MemberAssociationPeople / YCPeople repositories).
export const MEMBERSHIP_STATUS = {
  APPLIED: 'Applied',
  JOIN: 'Join',
  YES: 'Yes',
  REJECTED: 'Rejected',
  MEMBER_REJECTED: 'MemberRejected',
};

/**
 * Resolves what a user should see for one MA/YC membership, factoring in the
 * application status:
 *   - Yes                     => the association name (confirmed member)
 *   - Applied / Join          => "Waiting for the approval of the {org}"
 *   - Rejected / MemberRejected => "Rejected, please contact the {org}"
 *   - unknown/absent status   => the association name if the user is still linked
 *                                (legacy members / officers), otherwise null
 *
 * @param {object}   params
 * @param {string}   params.status  the people-row status
 * @param {string}   params.orgName association name (used only when confirmed)
 * @param {string}   params.orgType short org label passed to the messages ("MA" / "YC")
 * @param {Function} params.t       i18next translator
 * @returns {string|null}
 */
const getMembershipLabel = ({ status, orgName, orgType, t }) => {
  switch (status) {
    case MEMBERSHIP_STATUS.YES:
      return orgName || null;
    case MEMBERSHIP_STATUS.APPLIED:
    case MEMBERSHIP_STATUS.JOIN:
      return t('page.user.membership.waitingApproval', { org: orgType });
    case MEMBERSHIP_STATUS.REJECTED:
    case MEMBERSHIP_STATUS.MEMBER_REJECTED:
      return t('page.user.membership.rejected', { org: orgType });
    default:
      // No (recognised) application row: fall back to the linked association name,
      // preserving the previous behaviour for legacy members and MA/YC officers.
      return orgName || null;
  }
};

export default getMembershipLabel;
